import axios from 'axios'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import store from '@/store'
import md5 from 'md5'
import { isMoment } from 'moment'
import {ACCESS_TOKEN} from "@/store/mutation-types";

// 创建 axios 实例
const request = axios.create({
    // API 请求的默认前缀
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
    if (error.response) {
        const data = error.response.data
        // 从 localstorage 获取 token
        if (error.response.status === 403) {
            notification.error({
                message: 'Forbidden',
                description: data.message
            })
        }
        if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
            notification.error({
                message: '未授权',
                description: '请登录后操作'
            })
            setTimeout(() => {
                store.dispatch('Kickout')
            }, 500)
        }
        if (error.response.status === 500 || error.response.status === 400) {
            // 仅order, 不包含子路径
            if (error.request.responseURL.indexOf('/api/points/order/create?') < 0) {
                notification.error({
                    message: '错误',
                    description: data.msg || '操作失败，请联系管理员',
                    duration: null
                })
            }
        }
    }
    return Promise.reject(error)
}

function getTrivial (val) {
    if (Array.isArray(val)) {
        return val.map(v => getTrivial(v))
    } else if (isMoment(val)) {
        return val.toISOString()
    }
    return val
}

function convertToTrivial (obj) {
    if (obj) {
        Object.entries(obj).forEach(([key, value]) => {
            obj[key] = getTrivial(value)
        })
    }
}

// request interceptor
request.interceptors.request.use(config => {
    const _appid = '166916651616651'
    const secret = '89dfsq8gefj76s5hys3te3904rie3n0q'
    const _t = Date.now()
    const _type = 1

    // 处理路径
    let configUrl = config.url
    if (!config.url.startsWith('/')) {
        configUrl = '/' + config.url
    }
    if (config.url.endsWith('/')) {
        configUrl = configUrl.slice(0, configUrl.length - 1)
    }

    convertToTrivial(config.params)

    const paramsConfig = {}
    Object.assign(paramsConfig, config.params)

    if (config.data) {
        Object.assign(paramsConfig, {
            body: JSON.stringify(config.data)
        })
    }
    const paramsString = Object.entries(paramsConfig)
        .filter(pair => typeof pair[1] !== 'undefined' && pair[1] !== null)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .reduce((acc, p) => acc + `${p[0]}${p[1]}`, '')

    const stgUnsigned = paramsString + _type + configUrl + secret
    const unsigned = paramsString + _type + configUrl + _t + secret

    const sign = str => md5(str)
    config.params = {
        ...config.params,
        _appid,
        _t,
        _type,
        _sign: sign(unsigned),
        _stg: sign(stgUnsigned)
    }
    const token = storage.get(ACCESS_TOKEN)
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
        config.headers['sdscmall'] = `Bearer ${token}`
    }
    return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
    return response.data
}, errorHandler)

const installer = {
    vm: {},
    install (Vue) {
        Vue.use(VueAxios, request)
    }
}

export default request

export {
    installer as VueAxios,
    request as axios
}
